(function () {
    'use strict';

    angular
        .module('rms.common')
        .filter('emailLabel', emailLabel);

    function emailLabel() {
        return function(value) {
            return `${value.full_name || ''} (${value.email || ''})`;
        };
    }
})();